import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { BollettiniMeteoService } from './bollettini-meteo.service';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { MultiButtonRendererComponent } from 'app/generic/multi-button-renderer/multi-button-renderer.component';


@Component({
  selector: 'bollettini-meteo',
  templateUrl: './bollettini-meteo.component.html',
  styleUrls: ['./bollettini-meteo.component.scss'],
  providers: [BollettiniMeteoService]
})
export class BollettiniMeteoComponent implements OnInit {

  annoSelezione = new Date().getFullYear();
  modelList: any[] = [];
  promiseBusy: Promise<any[]>;
  promisePDF: Promise<any>;
  PDFbyte: any;
  showYearSelect: boolean = false;
  yearSelect: any[] = [];

  pagInizio: number = 0;
  pagFine: number = 100;
  numRisultati: number;
  showLoadMore: boolean = false;
  page: number = 1;

  actualPage: number = 1;
  gridOptions: any;
  data = [];
  @ViewChild('theModalDettaglio') theModalDettaglio: ElementRef;
  @ViewChild('errorModal') errorModal!: TemplateRef<any>;
  strHTML: string;
  strHTML2: string;
  numeroForTitle: any;
  modelPdf: any;
  private pdfObjectUrl: string | null = null;

  // datepicker
  today: NgbDateStruct;
  disableOutOfYear = (date: NgbDateStruct): boolean => {
    return date.year !== this.annoSelezione;
  };
  dataDa: any;
  dataA: any;
  isErroreDataDa: boolean = false;
  isErroreDataA: boolean = false;

  customLocaleText = {
    noRowsToShow: 'Nessun dato disponibile',
    loadingOoo: 'Caricamento in corso...',
    page: 'Pagina',
    of: 'di',
    more: 'Altro',
    to: 'a',
    contains: 'Contiene',
  };
  openFilters: boolean = false;

  constructor(
    public restService: BollettiniMeteoService,
    private modalService: NgbModal,
    private _sanitizer: DomSanitizer,
    private newModal: NewModalService,
  ) {
    const now = new Date();
    this.today = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate()
    };
  }

  ngOnInit() {
    this.createBollettiniList(this.annoSelezione);
    this.createYearSelect();
    this.setupAgSettings()
  }

  ngAfterViewInit() {
    // document.getElementById('nb-global-spinner').style.display = 'block';
  }

  setupAgSettings() {
    let ref = this;

    ref.gridOptions = {
      animateRows: true,
      pagination: true,
      paginationPageSize: 10,
      // localeText: AG_GRID_LOCALE_IT, //impostazioni lingua
      enableCellTextSelection: true, //per poter copiare il valore dal browser
      rowHeight: 50,
      suppressMovableColumns: true,
      defaultColDef: { //parametri di default per ogni colonna (gli stessi possono essere utilizzati singolarmente nei columnDefs)
        editable: false,
        filter: true, //viene visualizzata l'icona per inserire i filtri sulla colonna
        sortable: true, // permette l'ordinamento delle colonne
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellClass: 'fontClamp',
        headerClass: 'header-center',
        suppressMenu: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          // filterOptions: ['contains'], // per impostare le optioni di filtro di filtro
          suppressAndOrCondition: true, // per non far visualizzare le condizioni AND e OR
          // buttons: ["apply", "reset"],
        },
      },
      rowStyle: {
        background: '#fff',
        color: '#000'
      },
      columnDefs: [
        {
          headerName: "Data Emissione",
          field: "dataEmissione",
          filter: "agDateColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => {
            return params.value ? this.formattaDataInStringa(params.value) : "-";
          },
          filterParams: {
            comparator: this.compareDates,
            browserDatePicker: true,
            suppressAndOrCondition: true,
          },
        },
        {
          headerName: "Azioni",
          field: "buttons",
          cellRenderer: MultiButtonRendererComponent,
          filter: false,
          sortable: false,
          cellRendererParams: {
            value: [
              {
                label: 'Vedi dettaglio',
                class: 'clamp-icon icon now-ui-icons ui-1_zoom-bold btn btn-primary pointer',
                action: (row: any) => {

                  this.onUserRowSelect(row);
                }
              },
              {
                label: 'Scarica file',
                class: 'clamp-icon icon now-ui-icons arrows-1_cloud-download-93 btn btn-primary pointer',
                action: (row: any) => {

                  this.onDownloadSelect(row)
                }
              },
              /* {
                  label: "Effettua prenotazione",
                  class: 'fas fa-plus btn-first minPadding pointer',
                  action: (row: any) => {
                    ref.travelDetail = row;
                    ref.aggiungiViaggio(ref.travelDetail);
                  }
              } */
            ]
          }
        }
      ]
    }
  }

  formattaDataInStringa(data: Date | null): string {
    if (!data) return "-"; // Se la data è nulla, restituisci un valore predefinito

    const giorno = data.getDate().toString().padStart(2, "0"); // Assicura due cifre
    const mese = (data.getMonth() + 1).toString().padStart(2, "0"); // Mese da 0 a 11, quindi +1
    const anno = data.getFullYear();

    return `${giorno}/${mese}/${anno}`;
  }

  formattaDataPerNomeFile(data: Date | null): string {
    if (!data) return ""; // Se la data è nulla, restituisci stringa vuota

    const giorno = data.getDate().toString().padStart(2, "0");
    const mese = (data.getMonth() + 1).toString().padStart(2, "0");
    const anno = data.getFullYear();
    const ore = data.getHours().toString().padStart(2, "0");
    const minuti = data.getMinutes().toString().padStart(2, "0");

    return `${giorno}_${mese}_${anno} - ${ore}_${minuti}`;
  }

  applyDateFilter() {
    if (!this.gridOptions || !this.gridOptions.api) {
      return;
    }

    const dataDa = this.dataDa ? this.formatDate(this.dataDa) : null;
    const dataA = this.dataA ? this.formatDate(this.dataA) : null;

    this.gridOptions.api.setFilterModel({
      dataEmissione: {
        filterType: 'date',
        type: 'inRange',
        dateFrom: dataDa,
        dateTo: dataA
      }
    });

    this.gridOptions.api.onFilterChanged();
  }

  /**
   * Converte una data da NgbDateStruct a stringa formato YYYY-MM-DD
   */
  formatDate(ngbDate: any): string {
    if (!ngbDate) return null;
    const day = String(ngbDate.day).padStart(2, '0');
    const month = String(ngbDate.month).padStart(2, '0');
    const year = ngbDate.year;
    return `${year}-${month}-${day}`;
  }

  /**
   * Converte una stringa "DD/MM/YYYY - HH:MM" in "YYYY-MM-DD"
   */
  convertToISO(dateString: string): string {
    if (!dateString) return null;
    const dateParts = dateString.split(" - ")[0].split("/"); // Prende solo la parte "DD/MM/YYYY"
    if (dateParts.length !== 3) return null;
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`; // Converti in "YYYY-MM-DD"
  }




  onPaginationChanged(event: any) {
    let ref = this;

    if (event.newPage) {
      ref.actualPage = event.api.paginationGetCurrentPage() + 1;
    }
  };

  createBollettiniList(anno: number): void {
    this.data = [];

    this.restService.selectAllByAnnoReduced(anno)
      .then(res => {
        if (res != null) {
          res.forEach(element => {
            try {
              element.numeroAvviso = `${element.numeroAvviso}/${element.anno}`;

              // Converti le date in formato stringa "yyyy-MM-dd"
              element.dataEmissione = this.parseDateString(element.dataEmissione);
              element.dataDa = this.parseDateString(element.dataDa);
              element.dataA = this.parseDateString(element.dataA);
            } catch (error) {
              console.error('Errore nella conversione degli elementi:', error);
            }
          });

          this.data = res;
          this.modelList = res;
        }
      })
      .catch(error => {
        this.data = [];
        this.modelList = [];
        this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
      });
  }


  resetBollettini() {
    this.dataDa = null
    this.dataA = null
    this.createBollettiniList(this.annoSelezione)
  }

  findBollettiniPeriodo() {
    // Reset degli errori
    this.isErroreDataDa = false;
    this.isErroreDataA = false;

    if (!this.dataDa && !this.dataA) {
      this.newModal.open(
        "Attenzione",
        "Seleziona almeno una data",
        "bg-danger"
      );
      this.isErroreDataDa = true;
      this.isErroreDataA = true;
      return;
    }

    let dataDaMillis: number;
    let dataAMillis: number;

    if (this.dataDa && this.dataA) {
      dataDaMillis = this.toMillis(this.dataDa, 'start');
      dataAMillis = this.toMillis(this.dataA, 'end');

      if (dataDaMillis > dataAMillis) {
        this.newModal.open(
          "Attenzione",
          "La data di inizio non può essere maggiore di quella di fine",
          "bg-danger"
        );
        this.isErroreDataDa = true;
        this.isErroreDataA = true;
        return;
      }
    } else {
      const singleDate = this.dataDa || this.dataA;
      dataDaMillis = this.toMillis(singleDate, 'start');
      dataAMillis = this.toMillis(singleDate, 'end');
    }

    const filtered = this.modelList.filter((item) => {
      const emissionMillis = this.getTimeFromDate(item.dataEmissione);
      if (!emissionMillis) {
        return false;
      }

      if (dataDaMillis && emissionMillis < dataDaMillis) {
        return false;
      }

      if (dataAMillis && emissionMillis > dataAMillis) {
        return false;
      }

      return true;
    });

    if (!filtered.length) {
      this.newModal.open(
        "Attenzione",
        "Nessun bollettino presente nel periodo selezionato",
        "bg-warning"
      );
    }

    this.data = filtered;
  }

  toMillis(date: NgbDateStruct, mode: 'start' | 'end' = 'start'): number {
    if (!date) {
      return null;
    }

    const baseDate = new Date(date.year, date.month - 1, date.day);
    if (mode === 'end') {
      baseDate.setHours(23, 59, 59, 999);
    }
    return baseDate.getTime();
  }


  parseDateString = (dateString: string): Date | null => {
    if (!dateString) {
      return null;
    }

    const parts = dateString.split(" - ").map(part => part.trim());
    if (parts.length !== 2) {
      return null;
    }

    const firstPart = parts[0];
    const secondPart = parts[1];

    const datePart = firstPart.includes("/") ? firstPart : secondPart.includes("/") ? secondPart : null;
    const timePart = firstPart.includes(":") ? firstPart : secondPart.includes(":") ? secondPart : null;

    if (!datePart || !timePart) {
      return null;
    }

    const [day, month, year] = datePart.split("/").map(Number);
    const [hours, minutes] = timePart.split(":").map(Number);

    if ([day, month, year, hours, minutes].some(value => isNaN(value))) {
      return null;
    }

    return new Date(year, month - 1, day, hours, minutes);
  };

  private getTimeFromDate(date: Date | null): number | null {
    if (!date) {
      return null;
    }

    return date.getTime();
  }

  compareDates = (filterLocalDateAtMidnight: Date, cellValue: Date | string | null): number => {
    if (!cellValue) {
      return -1;
    }

    const cellDate =
      cellValue instanceof Date
        ? cellValue
        : this.parseDateString(cellValue);

    if (!cellDate) {
      return -1;
    }

    const normalizedCellDate = new Date(cellDate.getFullYear(), cellDate.getMonth(), cellDate.getDate());
    const normalizedFilterDate = new Date(
      filterLocalDateAtMidnight.getFullYear(),
      filterLocalDateAtMidnight.getMonth(),
      filterLocalDateAtMidnight.getDate()
    );

    if (normalizedCellDate.getTime() === normalizedFilterDate.getTime()) {
      return 0;
    }

    return normalizedCellDate < normalizedFilterDate ? -1 : 1;
  };

  onSelectChange(event: any) {
    this.createBollettiniList(event.currentTarget.value);
  }

  createYearSelect() {

    var yearStart = 2018;
    var nowYear = (new Date()).getFullYear();

    if ((nowYear - yearStart) > 0) {

      this.yearSelect.push(nowYear);
      while (nowYear > yearStart) {
        nowYear -= 1;
        this.yearSelect.push(nowYear);
      }
      this.showYearSelect = true;
    }

  }

  onUserRowSelect(event) {
    // document.getElementById('nb-global-spinner').style.display = 'block';

    var ref = this;
    this.restService.findByIdBollettino(event.idstatoMeteo).then(
      data => {
        if (data && data != null) {
          //ref.openModal(data.dataEmissione, data);
          this.restService.getPDFbyte(event.urlPdf).then(
            (res) => {
              if (res && res != null) {
                if (res && typeof res === 'object' && Object.keys(res).length === 0) {
                  this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
                } else {
                  const { url, safeUrl } = this.createPdfObjectUrl(res.file);
                  this.pdfObjectUrl = url;
                  this.modelPdf = safeUrl;
                  this.openModal(data.dataEmissione, this.modelPdf);
                }
              } else {
                this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
              }
            }
          ).catch((err) => {
            this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
          });
        } else {
          this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
        }
        //ref.openModal(data.numeroAvviso + "/" + data.anno, data);
      }
    );

  }

  onDownloadSelect(event) {

    // document.getElementById('nb-global-spinner').style.display = 'block';

    var ref = this;

    // Recupera la data dalla row (event.dataEmissione è già un oggetto Date)
    let dataEmissione: Date | null = event.dataEmissione;

    this.restService.findByIdBollettino(event.idstatoMeteo).then(
      res => {
        // Se event.dataEmissione non è disponibile, prova a usare res.dataEmissione
        if (!dataEmissione && res.dataEmissione) {
          // Se res.dataEmissione è una stringa, parsala
          if (typeof res.dataEmissione === 'string') {
            dataEmissione = this.parseDateString(res.dataEmissione);
          } else if (res.dataEmissione instanceof Date) {
            dataEmissione = res.dataEmissione;
          }
        }

        const dataFormattata = this.formattaDataPerNomeFile(dataEmissione);

        this.restService.getPDFbyte(res.urlPdf).then(
          res2 => {
            if (res2 && res2 != null) {
              if (res2 && typeof res2 === 'object' && Object.keys(res2).length === 0) {
                this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi. 6", "bg-danger");
              } else {
                console.log("Risposta API:", res2);
                console.log("Tipo di risposta:", typeof res2.file);
                var forExecElement = document.createElement('a');
                forExecElement.id = 'download_bollettino';
                forExecElement.href = 'data:application/pdf;base64,' + res2.file;
                forExecElement.download = 'bollettino_meteo_(' + dataFormattata + ').pdf';

                document.body.appendChild(forExecElement);
                document.getElementById('download_bollettino').click();
                document.body.removeChild(forExecElement);
              }
            } else {
              this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi. ", "bg-danger");
            }
          })
          .catch(error => {
            this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi. ", "bg-danger"); 
          }
          );
        //blob
        // this.restService.getPDFbyte(res.urlPdf).then(
        //   res2 => {
        //     const byteCharacters = atob(res2.file);
        //     const byteNumbers = new Array(byteCharacters.length);
        //     for (let i = 0; i < byteCharacters.length; i++) {
        //       byteNumbers[i] = byteCharacters.charCodeAt(i);
        //     }
        //     const byteArray = new Uint8Array(byteNumbers);
        //     const blob = new Blob([byteArray], { type: "application/pdf" });

        //     const link = document.createElement("a");
        //     link.href = window.URL.createObjectURL(blob);
        //     link.download = "avviso_allerta_(" + res2.dataEmissione + ").pdf";
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //   }
        // ).catch(error => {
        //   console.error("Errore durante il download del PDF:", error);
        // });

      }
    );

  }

  openModal(numeroBollettino: any, model: any) {
    this.numeroForTitle = numeroBollettino
    this.modelPdf = model;



    setTimeout(() => {
      this.modalService.open(this.theModalDettaglio, {
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
      });
    }, 200);
  }

  closeSingleModal(modal) {
    modal.close('close');
    if (this.pdfObjectUrl) {
      URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = null;
    }
    this.modelPdf = null;
  }

  openErrorModal(content: TemplateRef<any>) {
    this.modalService.open(content, { backdrop: 'static', keyboard: false });
  }

  switchOpen() {
    this.openFilters = !this.openFilters
  }

  // onSearch(query: string = '') {
  //   this.source.setFilter([
  //     // fields we want to include in the search
  //     {
  //       field: 'dataEmissione',
  //       search: query
  //     },
  //   ], false); 
  //   // second parameter specifying whether to perform 'AND' or 'OR' search 
  //   // (meaning all columns should contain search query or at least one)
  //   // 'AND' by default, so changing to 'OR' by setting false here
  // }

  // Helper per generare Blob URL sicuro per PDF
  private createPdfObjectUrl(base64: string): { url: string; safeUrl: SafeResourceUrl } {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
    return { url, safeUrl };
  }

}
